import React, { Component } from "react";
import { connect } from "react-redux";

import ProfileDrawer from "components/ProfileDrawer/ProfileDrawer";

import getApiGenerator from "services/getApiGenerator";
import {
  GET_NOTIFICATIONS_UNREAD,
  GET_INBOX_UNREAD,
  GET_USER_WIDGET
} from "services/api";
import { setProfileDrawer, setUser, setTeam } from "actions";
import { SINGLE_PROJECT_APP, ENABLE_INBOX } from "config";
import listenerServices from "services/listenerServices";
import sessionStorageService from "services/sessionStorageService";

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setProfileDrawer: info => {
      dispatch(setProfileDrawer(info));
    },
    setUser: user => {
      dispatch(setUser(user));
    },
    setTeam: team => {
      dispatch(setTeam(team));
    }
  };
};

export const mapStateToProps = (state, ownProps) => {
  return {
    /* For API calls */
    sessionKey: state.sessionKey,

    /* For user information */
    user: state.user,

    /* For rendering correct project links */
    projectId: state.projectId,

    /* For checking if profile drawer should even be rendered */
    project: state.project,

    /* Rendering notifications */
    notifications: state.profileDrawer.notifications,

    /* Rendering inbox unread */
    inboxUnread: state.profileDrawer.inboxUnread,

    /* For page changes */
    newPage: state.profileDrawer.newPage,

    /* For rendering points */
    points: state.profileDrawer.points,

    /* For determining project points and notifications */
    profileDrawer: state.profileDrawer,
    language: state.language
  };
};

export class ProfileDrawerContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null,
      isMobilePage: true // for defining mobile Project page
    };
  }

  componentDidMount() {
    /*
      Attaching listener for window resizes for rendering
      Profile Drawer in mobile Project page
    */
    listenerServices.addListener("resize", this.setMobilePage);

    /* perform the first check after component is mounted */
    this.setMobilePage();
  }

  componentWillUnmount() {
    /* Unmount listener for window resizes */
    listenerServices.removeListener("resize", this.setMobilePage);
  }

  setMobilePage = () => {
    const IS_640_DESKTOP_PROJECT =
      sessionStorageService.getItem("640_desktop_project") === "true"
        ? true
        : false;
    // 40em corresponds with $md-640 as our .scss variable, or 640px
    // 48em corresponds with $md as our .scss variable, or 768px
    let match = IS_640_DESKTOP_PROJECT
      ? window.matchMedia("(min-width: 40em)")
      : window.matchMedia("(min-width: 48em)");

    if (match.matches) {
      this.setState({ isMobilePage: false });
    } else {
      this.setState({ isMobilePage: true });
    }
  };

  getNotifications(project_id) {
    if (this.props.user.id === undefined) {
      return false;
    }
    getApiGenerator(
      GET_NOTIFICATIONS_UNREAD,
      { bundle_id: project_id },
      this.props.sessionKey
    ).end((err, res) => {
      if (err || res.body.code !== 200) {
      } else {
        this.props.setProfileDrawer({ notifications: res.body.unread });
      }
    });
  }

  getInboxUnread(project_id) {
    if (this.props.user.id === undefined) {
      return false;
    }
    getApiGenerator(
      GET_INBOX_UNREAD,
      { bundle_id: project_id },
      this.props.sessionKey
    ).end((err, res) => {
      if (err || res.body.code !== 200) {
      } else {
        this.props.setProfileDrawer({ inboxUnread: res.body.unreadCount });
      }
    });
  }

  getUser(project_id) {
    if (this.props.user.id === undefined) {
      return false;
    }
    getApiGenerator(
      GET_USER_WIDGET.format(this.props.user.id),
      { bundle_id: project_id },
      this.props.sessionKey
    ).end((err, res) => {
      if (err || res.body.code !== 200) {
      } else {
        this.props.setProfileDrawer({ points: res.body.points });
        this.props.setUser(res.body);
        if (res.body.team && res.body.team.id) {
          this.props.setTeam(res.body.team);
        }
      }
    });
  }

  isLoggedIn() {
    if (this.props.user && this.props.sessionKey) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let projChange = false;

    if (this.props.projectId !== this.state.projectId) {
      this.setState({ projectId: this.props.projectId });

      projChange = true;
    }

    // on each page change, get points and unread notifications
    if ((projChange || this.props.newPage) && this.props.sessionKey) {
      this.getNotifications(this.props.projectId);
      this.getInboxUnread(this.props.projectId);
      this.getUser(this.props.projectId);
      this.props.setProfileDrawer({ newPage: false });
    }
  }

  render() {
    const IS_MOBILE_PROJECT_PAGE =
      this.state.isMobilePage && this.props.profileDrawer.state === "project";

    if (
      this.props.profileDrawer.state === "no-profile-drawer" ||
      IS_MOBILE_PROJECT_PAGE
    ) {
      return null;
    } else {
      return (
        <ProfileDrawer
          user={this.props.user}
          projectId={this.props.projectId}
          project={this.props.project}
          notifications={this.props.notifications || 0}
          inboxUnread={this.props.inboxUnread || 0}
          points={this.props.points || 0}
          loggedIn={this.isLoggedIn()}
          singleProjectApp={SINGLE_PROJECT_APP}
          // passing in ENABLE_INBOX as a prop for Jest tests
          enableInbox={ENABLE_INBOX}
          language={this.props.language}
        />
      );
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileDrawerContainer);
